export default __webpack_public_path__ + "static/media/CardIcon.39a22966.svg";